/**
 * @desc Timeline Chart
 */
;(function () {
  angular
    .module('contrast.timeline')
    .factory('csTimelineChart', csTimelineChart)

  function csTimelineChart() {
    return {
      createChart: createChart,
      getConfigurableProperties: getConfigurableProperties
    }

    function getConfigurableProperties() {
      return [
        'margin',
        'itemHeight',
        'itemMargin',
        'height',
        'width',
        'hover',
        'mouseover',
        'mouseout',
        'click',
        'beginning',
        'ending',
        'labelMargin',
        'timeAccessor',
        'timeProperty',
        'plural',
        'label1Accessor',
        'label2Accessor',
        'label2Property',
        'label3Accessor',
        'label3Property',
        'label3ClassAccessor',
        'tooltipTemplateUrl',
        'tooltipProperties',
        'timeFormatter',
        'buildClusterTooltipHtmlAccessor',
        'process',
        'linePointClassAccessor',
        'endpoints',
        'circleClassAccessor',
        'pointWidth',
        'labelData',
        'tooltipAccessor'
      ]
    }

    function createChart() {
      var timeline = init

      var hover = function () {},
        mouseover = function () {},
        mouseout = function () {},
        click = undefined,
        timeAccessor = function (datum) {
          return datum ? datum[timeProperty] : undefined
        },
        linePointClassAccessor = function (datum) {
          return datum ? datum.lineClass : undefined
        },
        timeFormatter = function (time) {
          return moment(time).format('LT')
        },
        label1Accessor = function (datum) {
          return timeFormatter(timeAccessor(datum))
        },
        label2Accessor = function (datum) {
          return datum ? datum[label2Property] : undefined
        },
        label3Accessor = function (datum) {
          return datum ? datum[label3Property] : undefined
        },
        label3ClassAccessor = function (_d) {
          return ''
        },
        buildClusterTooltipHtmlAccessor = function (_c, _t) {
          return false
        },
        circleClassAccessor = function (_d) {
          return ''
        },
        tooltipAccessor = function () {
          return ''
        },
        width = null,
        height = null,
        beginning = 0,
        ending = 0,
        labelMargin = 0,
        margin = { left: 30, right: 30, top: 30, bottom: 30 },
        itemHeight = 30,
        itemMargin = 5,
        chartData = {},
        timeProperty = 'time',
        label2Property = 'label2',
        label3Property = 'label3',
        pointWidth = 80,
        plural = 'points',
        tooltipTemplateUrl = null,
        tooltipProperties = [],
        shouldProcess = true,
        endpoints = true,
        labelData = false

      angular.extend(timeline, {
        margin: marginGetterSetter,
        itemHeight: itemHeightGetterSetter,
        itemMargin: itemMarginGetterSetter,
        height: heightGetterSetter,
        width: widthGetterSetter,
        hover: hoverGetterSetter,
        mouseover: mouseoverGetterSetter,
        mouseout: mouseoutGetterSetter,
        click: clickGetterSetter,
        beginning: beginningGetterSetter,
        ending: endingGetterSetter,
        labelMargin: labelMarginGetterSetter,
        timeAccessor: timeAccessorGetterSetter,
        timeProperty: timePropertyGetterSetter,
        plural: pluralGetterSetter,
        label1Accessor: label1AccessorGetterSetter,
        label2Accessor: label2AccessorGetterSetter,
        label2Property: label2PropertyGetterSetter,
        label3Accessor: label3AccessorGetterSetter,
        label3Property: label3PropertyGetterSetter,
        label3ClassAccessor: label3ClassAccessorGetterSetter,
        buildClusterTooltipHtmlAccessor:
          buildClusterTooltipHtmlAccessorGetterSetter,
        tooltipTemplateUrl: tooltipTemplateUrlGetterSetter,
        tooltipProperties: tooltipPropertiesGetterSetter,
        timeFormatter: timeFormatterGetterSetter,
        process: processGetterSetter,
        linePointClassAccessor: linePointClassAccessorGetterSetter,
        endpoints: endpointsGetterSetter,
        circleClassAccessor: circleClassAccessorGetterSetter,
        pointWidth: pointWidthGetterSetter,
        labelData: labelDataGetterSetter,
        tooltipAccessor: tooltipAccessorGetterSetter
      })

      return timeline

      function init(container) {
        var endCirclesContainer = (lineContainer = container.append('g')),
          lineContainer = container.append('g'),
          g = container.append('g'),
          labelsContainer = container.append('g'),
          containerSize = container[0][0].getBoundingClientRect(),
          containerSelector = d3.select(container[0][0]),
          minTime = 0,
          maxTime = 0,
          scaleFactor = 0,
          clusteringDistance = 0,
          gSize = g[0][0].getBoundingClientRect(),
          refreshing = false

        setWidth()
        calculateExtremes()
        calculateScales()

        g.each(function (d) {
          chartData = d
        })
        refreshGraph()

        setHeight()

        timeline.update = function (newWidth, newHeight) {
          width = newWidth
          height = newHeight
          calculateScales()

          if (!refreshing) {
            refreshing = true
            refreshGraph()
            refreshing = false
          }
        }

        function refreshGraph() {
          calculateClustering()

          if (endpoints) {
            renderEndpoints()
          }
          renderPoints()
          renderLine()
        }

        function calculateExtremes() {
          if (ending === 0 || beginning === 0) {
            g.each(function (d) {
              d.forEach(function (datum) {
                var time = timeAccessor(datum)
                if (beginning === 0) {
                  if (time < minTime || minTime === 0) {
                    minTime = time
                  }
                }
                if (ending === 0) {
                  if (timeAccessor(datum) > maxTime) {
                    maxTime = time
                  }
                }
              })
            })

            if (ending === 0) {
              ending = maxTime
            }
            if (beginning === 0) {
              beginning = minTime
            }
          }
        }

        function calculateScales() {
          scaleFactor =
            (1 / (ending - beginning)) * (width - margin.left - margin.right)
          clusteringDistance = pointWidth / scaleFactor
        }

        function calculateXPosition(d) {
          return (
            margin.left +
            ((d.clusteredTime ? d.clusteredTime : timeAccessor(d)) -
              beginning) *
              scaleFactor
          )
        }

        function calculateTextXPosition(d) {
          return (
            margin.left +
            ((d.clusteredTime ? d.clusteredTime : timeAccessor(d)) -
              beginning) *
              scaleFactor
          )
        }

        function setHeight() {
          if (!height && !containerSelector.attr('height')) {
            height = gSize.height + gSize.top - containerSize.top
            d3.select(container[0][0]).attr('height', height)
          } else {
            if (!height) {
              height = containerSelector.attr('height')
            } else {
              containerSelector.attr('height', height)
            }
          }
        }

        function setWidth() {
          if (!width && !containerSize.width) {
            width = containerSelector.attr('width')
          } else if (!(width && containerSize.width)) {
            width = containerSelector.attr('width')
          }
        }

        function calculateClustering() {
          var i = 0,
            j = 0,
            k = 0,
            datum,
            datumTime,
            datum2,
            datum2Time

          for (; i < chartData.length; i++) {
            datum = chartData[i]
            datum.clusteredTime = undefined
            datum.clusteredPoints = undefined
          }

          chartData.sort(function (a, b) {
            return timeAccessor(a) - timeAccessor(b)
          })

          for (i = 0; i < chartData.length; i++) {
            datum = chartData[i]
            datumTime = timeAccessor(datum)

            if (!datum.clusteredTime) {
              for (j = i + 1; j < chartData.length; j++) {
                datum2 = chartData[j]
                datum2Time = timeAccessor(datum2)

                if (Math.abs(datum2Time - datumTime) <= clusteringDistance) {
                  datum2.clusteredTime = datumTime
                  if (!datum.clusteredPoints) {
                    datum.clusteredPoints = []
                  }
                  datum.clusteredPoints.push(datum2)

                  //If last, cluster on that point
                  if (j == chartData.length - 1) {
                    datum2.clusteredTime = undefined
                    datum2.clusteredPoints = datum.clusteredPoints

                    for (k = i; k < j; k++) {
                      chartData[k].clusteredTime = datum2Time
                      chartData[k].clusteredPoints = undefined
                    }
                  }
                }
              }
            }
          }
        }

        function getClusterArray(d) {
          // Create "cluster" array
          var all = [d]
          if (d.clusteredPoints && angular.isArray(d.clusteredPoints)) {
            all = all.concat(d.clusteredPoints)
          }

          // Sort by [eventName, status]

          // Map
          //  keys == eventName
          //  vals == array of objects matching the eventName
          var byName = {}
          all.forEach(function (o) {
            var name = o.eventName
            if (!byName[name]) {
              byName[name] = []
            }
            byName[name].push(o)
          })

          // Get distinct list of eventNames (keys of byName)
          // Sort alphabetically
          var names = Object.keys(byName).sort(function (a, b) {
            var a1 = a.toLowerCase()
            var b1 = b.toLowerCase()
            if (a1 < b1) {
              return -1
            } else if (a1 > b1) {
              return 1
            }
            return 0
          })

          // Build final array, sorted by [eventName, status]
          var final = []
          names.forEach(function (name) {
            var arr = byName[name].sort(function (a, b) {
              var a1 = a.status.toLowerCase()
              var b1 = b.status.toLowerCase()
              if (a1 < b1) {
                return -1
              } else if (a1 > b1) {
                return 1
              }
              return 0
            })
            final = final.concat(arr)
          })
          return final
        }

        function renderEndpoints() {
          endCirclesContainer.selectAll('.point-ring-highlight').remove()

          endCirclesContainer
            .append('circle')
            .attr('cx', margin.left)
            .attr('cy', itemHeight / 2)
            .attr('r', itemHeight / 2)
            .attr('class', function () {
              return (
                'point-ring-highlight' +
                (angular.isUndefined(click) ? ' point-no-click' : '')
              )
            })

          endCirclesContainer
            .append('circle')
            .attr('cx', width - margin.right)
            .attr('cy', itemHeight / 2)
            .attr('r', itemHeight / 2)
            .attr('class', function () {
              return (
                'point-ring-highlight' +
                (angular.isUndefined(click) ? ' point-no-click' : '')
              )
            })
        }

        function getTooltipTimeData(cluster) {
          var data = {}
          var found = cluster.find(function (o) {
            return !angular.isUndefined(o.clusteredTime)
          })
          if (!found) {
            return {}
          }
          data.timestamp = found.clusteredTime
          data.timeStr = timeFormatter(data.timestamp)
          return data
        }

        function processChartData() {
          var copy = angular.copy(chartData)
          var byX = {}
          copy.forEach(function (o) {
            o.x = calculateXPosition(o)
            if (!byX[o.x]) {
              byX[o.x] = {
                clustered: [],
                notClustered: []
              }
            }
            o.cluster = getClusterArray(o)
            o.isClustered = o.cluster.length > 1
            if (o.isClustered) {
              byX[o.x].clustered.push(o)
            } else {
              byX[o.x].notClustered.push(o)
            }
            o.timeData = o.isClustered ? getTooltipTimeData(o.cluster) : {}
            if (o.isClustered) {
              o.tooltipHtml = buildClusterTooltipHtmlAccessor(
                o.cluster,
                o.timeData
              )
            }
          })

          // Sort by x position
          copy.sort(function (a, b) {
            var a1 = a.x
            var b1 = b.x
            if (a1 < b1) {
              return -1
            } else if (a1 > b1) {
              return 1
            }
            return 0
          })

          var final = []
          Object.keys(byX).forEach(function (x) {
            var data = byX[x]
            if (data.clustered.length) {
              final.push(data.clustered[0])
            } else {
              final.push(data.notClustered[0])
            }
          })

          return final
        }

        function renderPoints() {
          g.selectAll('g.circle-group').remove()

          var processed = chartData
          if (shouldProcess) {
            processed = processChartData()
          } else {
            processed = _.sortBy(chartData, function (d) {
              return -timeAccessor(d)
            })
          }

          var circles = g
            .selectAll('g.circle-group')
            .data(processed, function (d) {
              return timeAccessor(d)
            })
          var labels = labelsContainer
            .selectAll('g.circle-group')
            .data(processed, function (d) {
              return timeAccessor(d)
            })

          if (labelData) {
            labels = labelsContainer
              .selectAll('g.circle-group')
              .data(labelData, function (d) {
                return timeAccessor(d)
              })
          }

          var circlesGroup = circles
            .enter()
            .append('g')
            .attr('class', function (d, i) {
              return (
                'circle-group circle-group-' + i + ' ' + circleClassAccessor(d)
              )
            })
            .attr('uib-tooltip-html', function (d) {
              return d.isClustered ? d.tooltipHtml : null
            })
            .attr('tooltip-class', function (d) {
              return d.isClustered ? 'medium-tooltip tooltip-robust' : null
            })
            .attr('tooltip-append-to-body', function (d) {
              return d.isClustered ? 'true' : null
            })
            .attr('tooltip-placement', function (d) {
              return d.isClustered ? 'top' : null
            })
            .classed('cluster', function (d) {
              return d.isClustered === true
            })
            .on('click', function (d, i) {
              if (angular.isDefined(click)) {
                click(d, i, processed)
              }
            })

          if (tooltipTemplateUrl && tooltipProperties.length > 0) {
            circlesGroup
              .attr('cs-time-series-tooltip', tooltipAccessor)
              .attr('template', tooltipTemplateUrl)

            for (var i = 0; i < tooltipProperties.length; i++) {
              var prop = tooltipProperties[i]
              circlesGroup.attr('tooltip-display-' + prop.name, prop.accessor)
            }
          }

          circlesGroup
            .append('circle')
            .attr('cx', calculateXPosition)
            .attr('cy', itemHeight / 2)
            .attr('r', itemHeight / 1.5)
            .attr('class', function (d, i) {
              return 'point-ring-outer point-ring-outer-' + i
            })

          circlesGroup
            .append('circle')
            .attr('cx', calculateXPosition)
            .attr('cy', itemHeight / 2)
            .attr('r', itemHeight / 3)
            .attr('class', function () {
              return (
                'point-ring' +
                (angular.isUndefined(click) ? ' point-no-click' : '')
              )
            })
            .on('mousemove', function (d, i) {
              hover(d, i, processed)
            })
            .on('mouseover', function (d, i) {
              mouseover(d, i, processed)
            })
            .on('mouseout', function (d, i) {
              mouseout(d, i, processed)
            })
            .attr('id', function (d, i) {
              if (processed.id && !d.id) {
                return 'timelineItem_' + processed.id
              }
              return d.id ? d.id : 'timelineItem_' + i
            })

          circlesGroup
            .append('circle')
            .attr('cx', calculateXPosition)
            .attr('cy', itemHeight / 2)
            .attr('r', itemHeight / 6)
            .attr('class', function () {
              return (
                'point-ring-center' +
                (angular.isUndefined(click) ? ' point-no-click' : '')
              )
            })

          renderLabels(labels)
        }

        function renderLabels(labels) {
          labelsContainer.selectAll('g.point-label').remove()

          var textGroup = labels
            .enter()
            .append('g')
            .attr('class', 'point-label')

          textGroup
            .append('text')
            .attr('x', calculateTextXPosition)
            .attr('y', getTextPositionFn(0))
            .attr('class', 'time-label')
            .text(function (d) {
              if (d.clusteredTime) {
                return ''
              }
              return label1Accessor(d)
            })

          textGroup
            .append('text')
            .attr('x', calculateTextXPosition)
            .attr('y', getTextPositionFn(1))
            .attr('class', function (d) {
              if (d.clusteredPoints) {
                return 'second-label bold'
              }
              return 'second-label'
            })
            .text(function (d) {
              if (d.clusteredTime) {
                return ''
              } else if (d.clusteredPoints) {
                return d.clusteredPoints.length + 1 + ' ' + plural
              }
              return label2Accessor(d)
            })

          textGroup
            .append('text')
            .attr('x', calculateTextXPosition)
            .attr('y', getTextPositionFn(2))
            .attr('class', function (d) {
              return 'third-label ' + label3ClassAccessor(d)
            })
            .text(function (d) {
              if (d.clusteredTime || d.clusteredPoints) {
                return ''
              }
              return label3Accessor(d)
            })
        }

        function renderLine() {
          lineContainer.selectAll('.timeline-line').remove()

          lineContainer
            .append('line')
            .attr('class', 'timeline-line')
            .attr('x1', margin.left)
            .attr('x2', width - margin.right)
            .attr('y1', itemHeight / 2)
            .attr('y2', itemHeight / 2)

          lineContainer.selectAll('.timeline-point-line').remove()

          var reverseData = _.sortBy(chartData, function (d) {
            return -timeAccessor(d)
          })

          var lineData = lineContainer
            .selectAll('.timeline-point-line')
            .data(reverseData, function (d) {
              return timeAccessor(d)
            })

          lineData
            .enter()
            .append('line')
            .attr('class', function (d) {
              return 'timeline-point-line ' + linePointClassAccessor(d)
            })
            .attr('x1', margin.left)
            .attr('x2', calculateXPosition)
            .attr('y1', itemHeight / 2)
            .attr('y2', itemHeight / 2)
        }

        function getTextPositionFn(labelNum) {
          return function (d) {
            return (
              margin.top +
              itemHeight * 0.75 +
              labelNum * 15 -
              (d.labelAbove ? 70 : 7)
            )
          }
        }
      }

      /*
       * Getters/Setters
       */

      function marginGetterSetter(p) {
        if (!arguments.length) {
          return margin
        }
        margin = p
        return timeline
      }

      function itemHeightGetterSetter(h) {
        if (!arguments.length) {
          return itemHeight
        }
        itemHeight = h
        return timeline
      }

      function itemMarginGetterSetter(h) {
        if (!arguments.length) {
          return itemMargin
        }
        itemMargin = h
        return timeline
      }

      function heightGetterSetter(h) {
        if (!arguments.length) {
          return height
        }
        height = h
        return timeline
      }

      function widthGetterSetter(w) {
        if (!arguments.length) {
          return width
        }
        width = w
        return timeline
      }

      function hoverGetterSetter(hoverFunc) {
        if (!arguments.length) {
          return hover
        }
        hover = hoverFunc
        return timeline
      }

      function mouseoverGetterSetter(mouseoverFunc) {
        if (!arguments.length) {
          return mouseover
        }
        mouseover = mouseoverFunc
        return timeline
      }

      function mouseoutGetterSetter(mouseoutFunc) {
        if (!arguments.length) {
          return mouseout
        }
        mouseout = mouseoutFunc
        return timeline
      }

      function clickGetterSetter(clickFunc) {
        if (!arguments.length) {
          return click
        }
        click = clickFunc
        return timeline
      }

      function beginningGetterSetter(b) {
        if (!arguments.length) {
          return beginning
        }
        beginning = b
        return timeline
      }

      function endingGetterSetter(e) {
        if (!arguments.length) {
          return ending
        }
        ending = e
        return timeline
      }

      function labelMarginGetterSetter(m) {
        if (!arguments.length) {
          return labelMargin
        }
        labelMargin = m
        return timeline
      }

      function timeAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return timeAccessor
        }
        timeAccessor = accessor
        return timeline
      }

      function timePropertyGetterSetter(property) {
        if (!arguments.length) {
          return timeProperty
        }
        timeProperty = property
        return timeline
      }

      function pluralGetterSetter(pluralWord) {
        if (!arguments.length) {
          return plural
        }
        plural = pluralWord
        return timeline
      }

      function label1AccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return label1Accessor
        }
        label1Accessor = accessor
        return timeline
      }

      function label2AccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return label2Accessor
        }
        label2Accessor = accessor
        return timeline
      }

      function label2PropertyGetterSetter(property) {
        if (!arguments.length) {
          return label2Property
        }
        label2Property = property
        return timeline
      }

      function label3AccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return label3Accessor
        }
        label3Accessor = accessor
        return timeline
      }

      function label3PropertyGetterSetter(property) {
        if (!arguments.length) {
          return label3Property
        }
        label3Property = property
        return timeline
      }

      function label3ClassAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return label3ClassAccessor
        }
        label3ClassAccessor = accessor
        return timeline
      }

      function buildClusterTooltipHtmlAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return buildClusterTooltipHtmlAccessor
        }
        buildClusterTooltipHtmlAccessor = accessor
        return timeline
      }

      function tooltipTemplateUrlGetterSetter(url) {
        if (!arguments.length) {
          return tooltipTemplateUrl
        }
        tooltipTemplateUrl = url
        return timeline
      }

      function tooltipPropertiesGetterSetter(properties) {
        if (!arguments.length) {
          return tooltipProperties
        }
        tooltipProperties = properties
        return timeline
      }

      function timeFormatterGetterSetter(formatter) {
        if (!arguments.length) {
          return timeFormatter
        }
        timeFormatter = formatter
        return timeline
      }

      function processGetterSetter(process) {
        if (!arguments.length) {
          return shouldProcess
        }
        shouldProcess = process
        return timeline
      }

      function linePointClassAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return linePointClassAccessor
        }
        linePointClassAccessor = accessor
        return timeline
      }

      function circleClassAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return circleClassAccessor
        }
        circleClassAccessor = accessor
        return timeline
      }

      function endpointsGetterSetter(show) {
        if (!arguments.length) {
          return endpoints
        }
        endpoints = show
        return timeline
      }

      function pointWidthGetterSetter(width) {
        if (!arguments.length) {
          return pointWidth
        }
        pointWidth = width
        return timeline
      }

      function labelDataGetterSetter(data) {
        if (!arguments.length) {
          return labelData
        }
        labelData = data
        return timeline
      }

      function tooltipAccessorGetterSetter(accessor) {
        if (!arguments.length) {
          return tooltipAccessor
        }
        tooltipAccessor = accessor
        return timeline
      }
    }
  }
})()
